/*
 * @Description: 项目模块
 * @Version: 1.0
 * @Autor: steFan
 * @Date: 2020-03-10 09:15:03
 * @LastEditors: steFan
 * @LastEditTime: 2020-04-01 15:19:13
 */
// import '@babel/polyfill'
import Vue from 'vue';
import router from './router/index';
import './element.js'
// import ElementUI from 'element-ui';
// Vue.use(ElementUI);
// import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import VueClipboard from 'vue-clipboard2'; //用于复制到粘贴板的插件
Vue.use(VueClipboard);
import VueAwesomeSwiper from 'vue-awesome-swiper'; //导入swiper
// import 'swiper/swiper-bundle.css'
import 'swiper/dist/css/swiper.min.css'
import axios from 'axios'
import i18n from './il8n/index'
// 文字滚动
import scroll from 'vue-seamless-scroll';
Vue.use(scroll);

import store from './store/store';
import utils from './utils/utils';
import nkhttp from './utils/nkhttp';

import './assets/js/rem';
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
    loading: require('./assets/images/loading.gif'),
    error: require('./assets/images/loading_error.svg'),
    attempt: 1
})  
// 导入图片预加载方法以及图片列表
// import {
//     imgsPreloader
// } from './utils/imgPreloader.js';
// import imgPreloaderList from './utils/imgPreloaderList.js';
import 'animate.css';
Vue.use(VueAwesomeSwiper /* { default options with global component } */ );

Vue.prototype.$axios = axios
Vue.prototype.$http = require('./utils/http.js').default;
Vue.prototype.$api = require('./utils/api.js');
Vue.prototype.$cache = require('./utils/cache.js');
Vue.prototype.$common = require('./utils/common.js').default;
Vue.prototype.$config = require('./utils/config.js').default;
Vue.prototype.$freeze = require('./utils/freeze.js').default;
Vue.prototype.$utils = utils;
Vue.prototype.$nkhttp = nkhttp;
Vue.config.productionTip = false;
(async () => {
    // await imgsPreloader(imgPreloaderList);
    //关闭加载弹框
    new Vue({
        router,
        store,
        i18n,
        render: (h) => h(App),
    }).$mount('#app');
})();